export type Language = 'es' | 'en'

export const translations = {
  es: {
    hero_badge: 'PARA GRADUADOS HISPANOS EN USA · BILINGÜE 🇺🇸🇲🇽',
    hero_h1_before: '¿Por qué ',
    hero_h1_highlight: 'rechazan tu CV',
    hero_h1_after: ' antes de que un humano lo vea?',
    hero_subtitle_before:
      'El Código Invisible de las corporaciones americanas — ',
    hero_subtitle_highlight: 'ahora en tus manos.',
    hero_supporting:
      'Deja de regalar tu título universitario en empleos de supervivencia.',
    hero_cta: 'QUIERO MI PRIMER EMPLEO CORPORATIVO',
    hero_price: 'Desde $6.36 — Disponible en Español e Inglés',
    hero_urgency: 'Oferta por tiempo limitado',

    pain_h2: 'Lo has hecho todo bien.',
    pain_p1_before:
      'Te graduaste. Tienes el título en la mano. Y te prometieron que en Estados Unidos ',
    pain_p1_quote: '"el que quiere, puede"',
    pain_p1_after: '.',
    pain_p2:
      'Pero llevas 3 meses enviando CVs a través de LinkedIn, Indeed y Glassdoor... y solo recibes el mismo correo genérico:',
    pain_rejection:
      '"Unfortunately, we have decided to move forward with other candidates."',
    pain_p3: 'O peor aún: Silencio absoluto.',
    pain_p4:
      'Mientras tanto, las facturas no esperan. Para sobrevivir, has aceptado un empleo que no requiere tu título. Sientes que tu inversión y tu esfuerzo se están desperdiciando.',

    problem_badge: 'EL ENEMIGO SILENCIOSO',
    problem_h2_before: '¿El problema? ',
    problem_h2_highlight: 'No es tu falta de capacidad.',
    problem_subtitle:
      'El problema es que estás usando reglas latinas en un juego americano.',
    problem_card1_title: 'El Error Común',
    problem_card1_p1_before:
      'Si tu CV tiene columnas, fotos, gráficos coloridos de Canva o palabras vagas... ',
    problem_card1_p1_highlight: 'eres invisible.',
    problem_card1_p2:
      'Para el sistema, simplemente no existes. Estás enviando documentos que el software no puede leer.',
    problem_card2_title: 'La Realidad ATS',
    problem_card2_p1_before:
      'En EE. UU., tu CV no lo lee una persona. Lo lee un algoritmo llamado ',
    problem_card2_p1_highlight: 'ATS (Applicant Tracking System)',
    problem_card2_p1_after: '.',
    problem_card2_p2:
      'Este robot decide tu futuro en milisegundos basándose en palabras clave y formato, no en tu potencial.',

    solution_label: 'LA SOLUCIÓN DEFINITIVA',
    solution_h2: 'Presentamos',
    solution_subtitle_before:
      'No te estamos dando una "plantilla bonita". Te estamos dando el ',
    solution_subtitle_highlight: 'Standardized Resume Logic',
    solution_subtitle_after: '.',
    solution_bilingual: 'App y eBook disponibles en Español e Inglés',
    solution_description:
      'Un sistema diseñado para hackear la psicología de los reclutadores americanos y superar el 99% de los filtros de software. Incluye nuestro eBook y la App de Ingeniería de Resumes.',
    solution_feature1: 'Formato validado por Fortune 500',
    solution_feature2: 'Optimización automática de palabras clave',
    solution_feature3: 'Estructura lógica que los reclutadores aman',
    solution_cta: 'OBTENER ACCESO INMEDIATO',
    solution_ats_label: 'ATS Score',
    solution_ats_value: '98/100 Match',

    benefits_h2_before: 'Con ',
    benefits_h2_after: ' lograrás:',
    benefits_1_title: 'Transliterar tu experiencia',
    benefits_1_desc:
      'Convertimos tus tareas en "Impacto Corporativo" que brilla ante los ojos de un Recruiter. No más traducciones literales que suenan mal.',
    benefits_2_title: 'Eliminar el Ghosting',
    benefits_2_desc:
      'Aprenderás a usar las palabras clave exactas que disparan las alertas de "High Match" en el sistema. Pasa de ignorado a entrevistado.',
    benefits_3_title: 'Generación Instantánea',
    benefits_3_desc:
      'Nuestra App hace el trabajo pesado por ti. Solo ingresas tu info y obtienes un documento validado para el mercado de USA en minutos.',

    cta_h2: 'No dejes que tu título se llene de polvo.',
    cta_subtitle:
      'Tu primera oportunidad corporativa está a un "clic" de distancia.',
    cta_bilingual: 'Disponible en Español e Inglés 🇺🇸🇲🇽',
    cta_tier1_badge: 'OFERTA ESPECIAL',
    cta_tier1_title: 'eBook CV Go',
    cta_tier1_price_label: 'Precio Regular:',
    cta_tier1_price_unit: 'USD · Pago único',
    cta_tier1_savings: 'Ahorras 68%',
    cta_tier1_f1: 'Guía completa del sistema ATS',
    cta_tier1_f2: 'Formato validado Fortune 500',
    cta_tier1_f3: 'Plantillas profesionales',
    cta_tier1_f4: 'Estrategias de palabras clave',
    cta_tier1_f5: 'Disponible en ES e EN',
    cta_tier1_cta: 'OBTENER eBOOK',
    cta_tier1_secure: 'Pago seguro',
    cta_tier2_badge: 'MÁS POPULAR 🔥',
    cta_tier2_title: 'Bundle CV Go',
    cta_tier2_subtitle: 'eBook + App de Ingeniería de Resumes',
    cta_tier2_price_label: 'Precio Regular:',
    cta_tier2_price_unit: 'USD / año',
    cta_tier2_savings: 'Ahorras 50%',
    cta_tier2_f1: 'Todo lo del eBook incluido',
    cta_tier2_f2: 'App de Ingeniería de Resumes',
    cta_tier2_f3: 'Generación instantánea de CVs',
    cta_tier2_f4: 'Optimización automática ATS',
    cta_tier2_f5: 'Actualizaciones incluidas',
    cta_tier2_f6: 'Soporte prioritario por email',
    cta_tier2_cta: 'OBTENER BUNDLE COMPLETO',
    cta_tier2_secure: 'Pago 100% Seguro y Encriptado',
    cta_rating: '4.9/5 Calificación Promedio',
    cta_social: 'Más de 2,000 graduados contratados',

    floating_title: 'CV Go — eBook + App',
    floating_subtitle: 'Tu primer empleo corporativo te espera',
    floating_price: 'Desde $6.36',
    floating_cta: 'VER OFERTAS',

    footer_copyright: 'CV Go. Todos los derechos reservados.',
    footer_terms: 'Términos y Condiciones',
    footer_privacy: 'Privacidad',
    footer_support: 'Soporte',
    footer_terms_title: 'Términos y Condiciones',
    footer_terms_updated: 'Última actualización: Febrero 2026',
    terms_section1_title: '1. Aceptación de los Términos',
    terms_section1_body:
      'Al acceder y utilizar CV Go, incluyendo nuestro eBook y la App de Ingeniería de Resumes, usted acepta estar sujeto a estos Términos y Condiciones. Si no está de acuerdo con alguna parte de estos términos, no debe utilizar nuestros servicios.',
    terms_section2_title: '2. Descripción del Servicio',
    terms_section2_body:
      'CV Go ofrece un eBook educativo y una aplicación de ingeniería de resumes diseñados para ayudar a profesionales hispanos a optimizar sus currículums para el mercado laboral de Estados Unidos. Nuestros productos son herramientas educativas y no garantizan la obtención de empleo.',
    terms_section3_title: '3. Licencia de Uso',
    terms_section3_body:
      'Al realizar la compra, usted recibe una licencia personal e intransferible para usar el eBook y/o la App según el plan adquirido. El eBook es de acceso de por vida con pago único. El Bundle (eBook + App) requiere una suscripción anual para mantener el acceso a la App. Queda prohibida la redistribución, reventa o compartición del contenido.',
    terms_section4_title: '4. Pagos y Reembolsos',
    terms_section4_body:
      'Todos los precios están expresados en dólares estadounidenses (USD). El eBook tiene un costo único de $6.36. El Bundle tiene un costo anual de $24.99. Ofrecemos una garantía de satisfacción de 7 días. Si no está satisfecho, puede solicitar un reembolso completo dentro de los primeros 7 días posteriores a la compra.',
    terms_section5_title: '5. Propiedad Intelectual',
    terms_section5_body:
      'Todo el contenido de CV Go, incluyendo textos, diseños, plantillas, algoritmos y marca, es propiedad exclusiva de CV Go. Está prohibida la reproducción, distribución o modificación del contenido sin autorización expresa por escrito.',
    terms_section6_title: '6. Limitación de Responsabilidad',
    terms_section6_body:
      'CV Go proporciona herramientas educativas para la optimización de currículums. No somos una agencia de empleo ni garantizamos resultados específicos. El éxito en la búsqueda de empleo depende de múltiples factores fuera de nuestro control. Nuestros productos se proporcionan "tal cual" sin garantías de ningún tipo.',
  },
  en: {
    hero_badge: 'FOR HISPANIC GRADUATES IN THE USA · BILINGUAL 🇺🇸🇲🇽',
    hero_h1_before: 'Why is your ',
    hero_h1_highlight: 'resume rejected',
    hero_h1_after: ' before a human even sees it?',
    hero_subtitle_before: 'The Invisible Code of American corporations — ',
    hero_subtitle_highlight: 'now in your hands.',
    hero_supporting: 'Stop wasting your degree on survival jobs.',
    hero_cta: 'I WANT MY FIRST CORPORATE JOB',
    hero_price: 'Starting at $6.36 — Available in English & Spanish',
    hero_urgency: 'Limited time offer',

    pain_h2: 'You did everything right.',
    pain_p1_before:
      'You graduated. You have the degree in hand. And they promised you that in America, ',
    pain_p1_quote: '"where there is a will, there is a way"',
    pain_p1_after: '.',
    pain_p2:
      'But you have been sending resumes through LinkedIn, Indeed, and Glassdoor for 3 months... and you only get the same generic email:',
    pain_rejection:
      '"Unfortunately, we have decided to move forward with other candidates."',
    pain_p3: 'Or worse: Complete silence.',
    pain_p4:
      'Meanwhile, the bills do not wait. To survive, you have accepted a job that does not require your degree. You feel like your investment and effort are being wasted.',

    problem_badge: 'THE SILENT ENEMY',
    problem_h2_before: 'The problem? ',
    problem_h2_highlight: 'It is not your lack of ability.',
    problem_subtitle:
      'The problem is you are playing an American game with Latin rules.',
    problem_card1_title: 'The Common Mistake',
    problem_card1_p1_before:
      'If your resume has columns, photos, colorful Canva graphics, or vague words... ',
    problem_card1_p1_highlight: 'you are invisible.',
    problem_card1_p2:
      'To the system, you simply do not exist. You are sending documents the software cannot read.',
    problem_card2_title: 'The ATS Reality',
    problem_card2_p1_before:
      'In the U.S., your resume is not read by a person. It is read by an algorithm called ',
    problem_card2_p1_highlight: 'ATS (Applicant Tracking System)',
    problem_card2_p1_after: '.',
    problem_card2_p2:
      'This robot decides your future in milliseconds based on keywords and format, not your potential.',

    solution_label: 'THE DEFINITIVE SOLUTION',
    solution_h2: 'Introducing',
    solution_subtitle_before:
      'We are not giving you a "pretty template". We are giving you the ',
    solution_subtitle_highlight: 'Standardized Resume Logic',
    solution_subtitle_after: '.',
    solution_bilingual: 'App and eBook available in English & Spanish',
    solution_description:
      'A system designed to hack the psychology of American recruiters and beat 99% of software filters. Includes our eBook and the Resume Engineering App.',
    solution_feature1: 'Fortune 500 validated format',
    solution_feature2: 'Automatic keyword optimization',
    solution_feature3: 'Logical structure that recruiters love',
    solution_cta: 'GET INSTANT ACCESS',
    solution_ats_label: 'ATS Score',
    solution_ats_value: '98/100 Match',

    benefits_h2_before: 'With ',
    benefits_h2_after: ' you will achieve:',
    benefits_1_title: 'Transliterate your experience',
    benefits_1_desc:
      'We convert your tasks into "Corporate Impact" that shines in the eyes of a Recruiter. No more literal translations that sound wrong.',
    benefits_2_title: 'Eliminate Ghosting',
    benefits_2_desc:
      'You will learn to use the exact keywords that trigger "High Match" alerts in the system. Go from ignored to interviewed.',
    benefits_3_title: 'Instant Generation',
    benefits_3_desc:
      'Our App does the heavy lifting for you. Just enter your info and get a document validated for the US market in minutes.',

    cta_h2: 'Do not let your degree collect dust.',
    cta_subtitle: 'Your first corporate opportunity is just one click away.',
    cta_bilingual: 'Available in English & Spanish 🇺🇸🇲🇽',
    cta_tier1_badge: 'SPECIAL OFFER',
    cta_tier1_title: 'CV Go eBook',
    cta_tier1_price_label: 'Regular Price:',
    cta_tier1_price_unit: 'USD · One-time payment',
    cta_tier1_savings: 'You save 68%',
    cta_tier1_f1: 'Complete ATS system guide',
    cta_tier1_f2: 'Fortune 500 validated format',
    cta_tier1_f3: 'Professional templates',
    cta_tier1_f4: 'Keyword strategies',
    cta_tier1_f5: 'Available in EN & ES',
    cta_tier1_cta: 'GET eBOOK',
    cta_tier1_secure: 'Secure payment',
    cta_tier2_badge: 'MOST POPULAR 🔥',
    cta_tier2_title: 'CV Go Bundle',
    cta_tier2_subtitle: 'eBook + Resume Engineering App',
    cta_tier2_price_label: 'Regular Price:',
    cta_tier2_price_unit: 'USD / year',
    cta_tier2_savings: 'You save 50%',
    cta_tier2_f1: 'Everything in the eBook included',
    cta_tier2_f2: 'Resume Engineering App',
    cta_tier2_f3: 'Instant resume generation',
    cta_tier2_f4: 'Automatic ATS optimization',
    cta_tier2_f5: 'Updates included',
    cta_tier2_f6: 'Priority email support',
    cta_tier2_cta: 'GET FULL BUNDLE',
    cta_tier2_secure: '100% Secure & Encrypted Payment',
    cta_rating: '4.9/5 Average Rating',
    cta_social: 'Over 2,000 graduates hired',

    floating_title: 'CV Go — eBook + App',
    floating_subtitle: 'Your first corporate job awaits',
    floating_price: 'From $6.36',
    floating_cta: 'SEE OFFERS',

    footer_copyright: 'CV Go. All rights reserved.',
    footer_terms: 'Terms & Conditions',
    footer_privacy: 'Privacy',
    footer_support: 'Support',
    footer_terms_title: 'Terms & Conditions',
    footer_terms_updated: 'Last updated: February 2026',
    terms_section1_title: '1. Acceptance of Terms',
    terms_section1_body:
      'By accessing and using CV Go, including our eBook and the Resume Engineering App, you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, you should not use our services.',
    terms_section2_title: '2. Description of Service',
    terms_section2_body:
      'CV Go offers an educational eBook and a resume engineering application designed to help Hispanic professionals optimize their resumes for the United States job market. Our products are educational tools and do not guarantee employment.',
    terms_section3_title: '3. License of Use',
    terms_section3_body:
      'Upon purchase, you receive a personal, non-transferable license to use the eBook and/or the App according to the plan acquired. The eBook provides lifetime access with a one-time payment. The Bundle (eBook + App) requires an annual subscription to maintain App access. Redistribution, resale, or sharing of content is prohibited.',
    terms_section4_title: '4. Payments and Refunds',
    terms_section4_body:
      'All prices are expressed in US dollars (USD). The eBook has a one-time cost of $6.36. The Bundle has an annual cost of $24.99. We offer a 7-day satisfaction guarantee. If you are not satisfied, you may request a full refund within the first 7 days after purchase.',
    terms_section5_title: '5. Intellectual Property',
    terms_section5_body:
      'All CV Go content, including texts, designs, templates, algorithms, and branding, is the exclusive property of CV Go. Reproduction, distribution, or modification of content without express written authorization is prohibited.',
    terms_section6_title: '6. Limitation of Liability',
    terms_section6_body:
      'CV Go provides educational tools for resume optimization. We are not an employment agency and do not guarantee specific results. Success in job searching depends on multiple factors beyond our control. Our products are provided "as is" without warranties of any kind.',
  },
}
